<div class="communication-page">
  <div class="page-header">
    <div>
      <h2>Chats</h2>
      <p>Search staff for one-to-one chats or create groups for team conversations.</p>
    </div>
  </div>

  <section class="quick-start">
    <div class="direct-search">
      <mat-form-field appearance="outline">
        <mat-label>Select user for direct chat</mat-label>
        <mat-select [(value)]="selectedDirectUser" (selectionChange)="onDirectUserSelected($event.value)" panelClass="chat-user-select-panel">
          <mat-option>
            <input
              matInput
              class="select-search-input"
              [(ngModel)]="userSearchTerm"
              placeholder="Search users"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            >
          </mat-option>
          <mat-option *ngFor="let user of filteredUsers" [value]="user">
            {{ user.fullName || user.email }}
            <span class="option-meta">{{ user.department || user.position || user.email || 'Staff user' }}</span>
          </mat-option>
          <mat-option *ngIf="!filteredUsers.length" disabled>
            {{ loadingUsers ? 'Loading users...' : 'No matching users found.' }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="create-panel">
      <mat-form-field appearance="outline">
        <mat-label>Group name</mat-label>
        <input matInput [(ngModel)]="newGroupName" placeholder="e.g. Finance Team">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Members</mat-label>
        <mat-select multiple [(value)]="selectedGroupMembers" panelClass="chat-user-select-panel">
          <mat-option>
            <input
              matInput
              class="select-search-input"
              [(ngModel)]="groupMemberSearchTerm"
              placeholder="Search users"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
            >
          </mat-option>
          <mat-option *ngFor="let user of filteredGroupMemberUsers" [value]="user">
            {{ user.fullName || user.email }}
            <span class="option-meta">{{ user.department || user.position || user.email || 'Staff user' }}</span>
          </mat-option>
          <mat-option *ngIf="!filteredGroupMemberUsers.length" disabled>
            {{ loadingUsers ? 'Loading users...' : 'No matching users found.' }}
          </mat-option>
        </mat-select>
        <mat-hint>Choose at least 3 users</mat-hint>
      </mat-form-field>

      <button mat-flat-button color="primary" [disabled]="!canCreateGroup" (click)="createGroup()">Create Group</button>
      <div class="group-error" *ngIf="groupError">{{ groupError }}</div>
    </div>
  </section>

  <div class="chat-layout">
    <aside class="group-list">
      <div class="thread-section-title">
        <span>Direct Chats</span>
        <span class="section-badge" *ngIf="directUnreadCount">{{ directUnreadCount > 99 ? '99+' : directUnreadCount }}</span>
      </div>
      <button
        type="button"
        class="group-row"
        *ngFor="let thread of directThreads"
        [class.active]="selectedThread === thread"
        (click)="selectThread(thread)"
      >
        <span class="avatar direct">{{ thread.name.charAt(0) }}</span>
        <span class="group-copy">
          <strong>{{ thread.name }}</strong>
          <small>{{ thread.lastMessage }}</small>
        </span>
        <span class="badge" *ngIf="thread.unread">{{ thread.unread }}</span>
      </button>

      <div class="thread-section-title">
        <span>Group Chats</span>
        <span class="section-badge" *ngIf="groupUnreadCount">{{ groupUnreadCount > 99 ? '99+' : groupUnreadCount }}</span>
      </div>
      <button
        type="button"
        class="group-row"
        *ngFor="let thread of groupThreads"
        [class.active]="selectedThread === thread"
        (click)="selectThread(thread)"
      >
        <span class="avatar">{{ thread.name.charAt(0) }}</span>
        <span class="group-copy">
          <strong>{{ thread.name }}</strong>
          <small>{{ thread.lastMessage }}</small>
        </span>
        <span class="badge" *ngIf="thread.unread">{{ thread.unread }}</span>
      </button>
    </aside>

    <section class="chat-panel">
      <ng-container *ngIf="selectedThread; else emptyChatState">
      <div class="chat-head">
        <div>
          <h3>{{ selectedThread.name }}</h3>
          <p>
            {{ selectedThread.type === 'direct' ? 'Direct chat' : (selectedThread.members.length + ' members') }}:
            {{ selectedThread.members.join(', ') }}
          </p>
        </div>
      </div>

      <div class="messages">
        <div class="bubble" *ngFor="let message of activeConversation" [class.mine]="message.sender === 'You'">
          <strong>{{ message.sender }}</strong>
          <p>{{ message.text }}</p>
          <small>{{ message.pending ? 'Sending...' : message.time }}</small>
        </div>
      </div>

      <div class="composer">
        <mat-form-field appearance="outline">
          <mat-label>Write a chat message</mat-label>
          <input matInput [(ngModel)]="draftMessage" (keyup.enter)="sendChat()">
        </mat-form-field>
        <button mat-flat-button color="primary" (click)="sendChat()">Send</button>
      </div>
      </ng-container>
      <ng-template #emptyChatState>
        <div class="empty-chat-state">
          <h3>{{ loadingThreads ? 'Loading chats...' : 'No chat selected' }}</h3>
          <p>Select a user for direct chat or create a group to begin.</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>
